import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeviceMountCeiling = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 6H20V9H16V11C16 12.6569 14.6569 14 13 14H7C5.34315 14 4 12.6569 4 11V9H0V6ZM7 8H13V7H7V8ZM14 8H19V7H14V8ZM5 9V11C5 12.1046 5.89543 13 7 13H13C14.1046 13 15 12.1046 15 11V9H5ZM1 7H6V8H1V7Z",
		fill: "currentColor"
	})
});
export default SvgDeviceMountCeiling;
